import React from 'react';

import { Formik, Form as FormikForm } from 'formik';

import { Button, Modal } from '@shared/components/bootstrap';
import { FormikInputFormGroup } from '@shared/components/fields/formik/formik_input_form_group';

import { FormikHTMLFormGroup } from '@admin/components/fields/formik/formik_html_form_group';
import { type Landing__Location__TopicInput } from '@admin/schema';

export const LandingLocationTopicModal: React.FC<{
  topic?: Landing__Location__TopicInput;
  onClose(): void;
  onSave(input: Landing__Location__TopicInput): void;
}> = ({ topic, onClose, onSave }) => {
  const onSubmit = (input: Landing__Location__TopicInput) => {
    if (!input.name || !input.blurb) return;
    onSave(input);
  };

  return (
    <Modal onClose={onClose}>
      <Formik<Landing__Location__TopicInput>
        initialValues={{
          name: topic?.name ?? '',
          blurb: topic?.blurb ?? '',
        }}
        onSubmit={onSubmit}
      >
        <FormikForm>
          <Modal.Content>
            <Modal.Header>
              <Modal.Title>FAQ</Modal.Title>
              <Modal.Close close={onClose} />
            </Modal.Header>
            <Modal.Body>
              <FormikInputFormGroup id="name" name="name" label="Question:" />
              <FormikHTMLFormGroup id="blurb" name="blurb" label="Answer:" />
            </Modal.Body>
            <Modal.Footer>
              <Button type="submit" kind="primary">
                Save
              </Button>
            </Modal.Footer>
          </Modal.Content>
        </FormikForm>
      </Formik>
    </Modal>
  );
};
